
import { Component } from 'vue-property-decorator';
import RepsolFilterBarComponent from '@/components/repsol-filter-bar/RepsolFilterBarComponent.vue';
import RepsolFilterChipsComponent from '@/components/repsol-filter-chips/RepsolFilterChipsComponent.vue';
import RepsolTableComponent from '@/components/repsol-table/RepsolTableComponent.vue';
import RepsolFormPopupComponent from '@/components/repsol-form-popup/RepsolFormPopupComponent.vue'
import { Chip, FormFields, FilterFields, TableHeaderModel } from '@/models/repsol-template.model';
import ComponentBase from '@/mixins/componentBase';
import RepsolDialog from '@/components/RepsolDialog.vue';

@Component({
  name: 'ProductosPage',
  components: {
    RepsolFilterBarComponent,
    RepsolFilterChipsComponent,
    RepsolTableComponent,
    RepsolFormPopupComponent,
    RepsolDialog
  },
})



export class ProductosPage extends ComponentBase {

  isOpenFilters = false;
  isOpenForm = false;
  formIsValid = true;
  formOnlyRead = false;

  deleteFilter = "";

  popupHeaderText = "";

  filterChips: Chip[] = [];

  filterFields: FilterFields[] = [];

  formFields: FormFields[] = [];

  items: any[] = [];

  maestroUsuariosNotificacionAltura: any[] = [];

  itemEdit: any = {};

  tableHeaders: TableHeaderModel[] = [];

  itemEliminar: any = {};

  showDialog = false;

  showMessage = false;

  tableLoading = false;
  totalItems = 0;

  tableOptions = {
    page: 1,
    itemsPerPage: 10,
    sortBy: [] as string[],
    sortDesc: [] as boolean[],
  };

  constructor() {
    super();
  }

  mounted() {
    this.formFields = [
      {
        label: 'common.market',
        name: 'mercadoId',
        as: 'selectlist',
        model: '',
        isDisabled: false,
        isRequired: true,
        items: this.maestroMercado,
        canView: true,
        cols: 4,
      },
      {
        label: 'common.code',
        name: 'codigo',
        as: 'text',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 4,
      },
      {
        label: 'common.name',
        name: 'nombre',
        as: 'text',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 4,
      },
      {
        label: 'productos.market_code',
        name: 'codigoMercado',
        as: 'text',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 3,
      },


      {
        label: 'productos.initial_limit',
        name: 'limiteInicial',
        as: 'number',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 3,
        tooltip: 'productos.initial_limit_tooltip',
      },
      {
        label: 'productos.upper_limit',
        name: 'limiteSuperior',
        as: 'number',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 3,
        tooltip: 'productos.upper_limit_tooltip',
      },
      {
        label: 'productos.triton_code',
        name: 'codigoTriton',
        as: 'text',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 3,
      },
      {
        label: 'productos.default_close_time',
        name: 'horaCierrePorDefecto',
        as: 'time',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 3,
        tooltip: 'productos.default_close_time_tooltip',
      },
      {
        label: 'productos.default_close_day',
        name: 'diaCierreLineaPorDefecto',
        as: 'number',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 3,
        tooltip: 'productos.default_close_day_tooltip',
      },
      {
        label: 'productos.line_close_1',
        name: 'mesesCierre1Linea',
        as: 'number',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 3,
        tooltip: 'productos.line_close_1_tooltip',

      },
      {
        label: 'productos.line_close_2',
        name: 'mesesCierre2Linea',
        as: 'number',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 3,
        tooltip: 'productos.line_close_2_tooltip',
      },
      {
        label: 'productos.preparation_minutes',
        name: 'minCierreOperacionesPrevioAlCierre',
        as: 'number',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 4,
        tooltip: 'productos.preparation_minutes_tooltip',
      },
      {
        label: 'productos.commissions_strategy',
        name: 'estrategiaComisiones',
        as: 'text',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 4,
        tooltip: 'productos.commissions_strategy_tooltip',
      },
      {
        label: 'productos.commissions_trader_code',
        name: 'codigoTraderComisiones',
        as: 'text',
        model: '',
        isDisabled: false,
        isRequired: true,
        canView: true,
        cols: 4,
        tooltip: 'productos.commissions_trader_code_tooltip',
      },
      {
        label: 'common.desk',
        name: 'codigosMesas',
        as: 'selectlist',
          model: [],
        isDisabled: false,
        isRequired: true,
        items: this.maestroMesaEscritura,
        canView: true,
        cols: 4,
        multiple: true,
      },
      {
        label: 'productos.automatic_close',
        name: 'cierreAutomatico',
        as: 'radio',
        items: this.maestroSiNo,
        model: '',
        isDisabled: false,
        isRequired: false,
        canView: true,
        cols: 3,
        tooltip: 'productos.automatic_close_tooltip',
      },      
      {
        label: 'common.active',
        name: 'activo',
        as: 'radio',
        items: this.maestroSiNo,
        model: '',
        isDisabled: false,
        isRequired: false,
        canView: true,
        cols: 3
      },
      {
        label: 'productos.send_triton',
        name: 'enviarATriton',
        as: 'radio',
        items: this.maestroSiNo,
        model: true,
        isDisabled: false,
        isRequired: false,
        canView: false,
        cols: 3,
  tooltip: 'productos.send_triton_tooltip',  
      },
       {
        label: 'productos.send_altura',
        name: 'enviarAltura',
        as: 'radio',
        items: this.maestroSiNo,
        model: true,
        isDisabled: false,
        isRequired: false,
        canView: true,
        cols: 3,
  tooltip: 'productos.send_altura_tooltip',  
      },
      {
        label: 'productos.altura_notification_recipients',
        name: 'destinatariosNotificacionAltura',
        as: 'combobox',
        model: [],
        isDisabled: false,
        isRequired: false,
        items: this.maestroUsuariosNotificacionAltura,
        multiple: true,
        canView: true,
        cols: 6,
        tooltip: 'productos.altura_notification_recipients_tooltip',
      }

    ];

  // Here to make the new field fileterable
    this.filterFields = [
      {
        label: 'common.code',
        name: 'codigo',
        as: 'text',
        model: '',
        isDisabled: false,
        isRequired: false
      },
      {
        label: 'common.name',
        name: 'nombre',
        as: 'text',
        model: '',
        isDisabled: false,
        isRequired: false
      },
      {
        label: 'productos.market_code',
        name: 'codigoMercado',
        as: 'text',
        model: '',
        isDisabled: false,
        isRequired: false
      },
      {
        label: 'productos.triton_code',
        name: 'codigoTriton',
        as: 'text',
        model: '',
        isDisabled: false,
        isRequired: false
      }];

    this.tableHeaders = [
      { text: 'common.identifier', value: "id", sortable: true, as: 'number' },
      { text: "common.code", value: "codigo", sortable: true, as: 'text' },
      { text: "common.name", value: "nombre", sortable: true, as: 'text' },
      { text: "productos.market_code", value: "codigoMercado", sortable: true, as: 'number' },
      { text: "productos.triton_code", value: "codigoTriton", sortable: true, as: 'number' },
      { text: "common.market", value: "mercadoId", sortable: true, as: 'select', tooltip: true, items: this.maestroMercado },
      { text: "productos.initial_limit", value: "limiteInicial", sortable: true, as: 'number' },
      { text: "productos.upper_limit", value: "limiteSuperior", sortable: true, as: 'number' },
      { text: "productos.automatic_close", value: "cierreAutomatico", sortable: false, as: 'select', items: this.maestroSiNo },
      { text: "common.active", value: "activo", sortable: true, as: 'select', items: this.maestroSiNo },
      

      {
        text: '', value: "actions", sortable: false, as: '', actions: [
          { icon: 'mdi-close', name: 'eliminar' },
          { icon: 'edit', name: 'editar' }
        ]
      }
    ];

    this.getProductosList();

    this.getMaestroCierreEstado();
    this.getMaestroConsolidadoNeteoDetalleEjecucionTipo();
    this.getMaestroMercado();
    this.getMaestroMesa();
    this.getMaestroOperacionEstado();
    this.getMaestroOperacionTipo();
    this.getMaestroPerfil();
    this.getMaestroProducto();
    this.loadUsuariosNotificacionAltura();

  }

  private loadUsuariosNotificacionAltura(): void {
    
    const allowed = new Set(['ADM', 'MESA']);
    this.maestroUsuariosNotificacionAltura.splice(0);

    // Use the same endpoint as Administración > Usuarios because it includes perfilId.
    // Request a large page size to avoid server-side pagination truncating the list.
    this.post({ apiUrl: '/api/usuario/list', entity: { PageNumber: 1, PageSize: 10000 } }) 
      .then((data: any) => {
        const seenIds = new Set<string>();
        const rows = Array.isArray(data) ? data : (data?.items ?? []);        
        (rows || []).forEach((u: any) => {
          const activoRaw = u?.activo ?? u?.isActivo ?? u?.activoUsuario;
          const activo = activoRaw === true || activoRaw === 1 || activoRaw === '1' || String(activoRaw).toLowerCase() === 'true';
          if (!activo) {
            return;
          }

          const perfilId = String(u?.perfilId ?? '').toUpperCase();
          if (!allowed.has(perfilId)) {
            return;
          }

          const rawId = u?.idUsuario ?? u?.usuarioId ?? u?.id ?? u?.identificador ?? u?.codigoUsuario ?? u?.email;
          const idKey = rawId != null ? String(rawId) : '';
          if (!idKey || seenIds.has(idKey)) {
            return;
          }
          seenIds.add(idKey);

          const baseNombre = u?.nombre ?? u?.name ?? u?.codigoUsuario ?? u?.email ?? idKey;
          const email = u?.email ? String(u.email) : '';
          const nombre = email && !String(baseNombre).includes(email)
            ? `${baseNombre} (${email})`
            : String(baseNombre);

          this.maestroUsuariosNotificacionAltura.push({
            ...u,
            id: rawId,
            email,
            nombre,
          });
        });
      })
      .catch(() => {
        // Keep it empty if the endpoint fails; we don't want to show wrong users.
        this.maestroUsuariosNotificacionAltura.splice(0);
      });
  }

  onTableOptionsChanged(options: any) {
  this.tableOptions = { ...options };
    this.getProductosList();
  }

  async getProductosList() {
    this.openSpinner("productos.cargarListado");
    this.items = [];
    const filtro: any = {};
    this.filterFields.forEach(f => {
      if (f.model) {
        filtro[f.name] = f.model;
      }
    });

    const page = this.tableOptions?.page ?? 1;
    const itemsPerPage = this.tableOptions?.itemsPerPage ?? 10;
    const sortBy = this.tableOptions?.sortBy ?? [];
    const sortDesc = this.tableOptions?.sortDesc ?? [];
    filtro.PageNumber = page || 1;
    filtro.PageSize = itemsPerPage || 10;

    if (sortBy && sortBy.length) {
      filtro.sortBy = sortBy[0];
      filtro.sortDesc = !!(sortDesc && sortDesc[0]);
    }

    const route = '/api/producto/list';
    await this.post({ apiUrl: route, entity: filtro })
      .then(data => {
          console.log(data.items);
        if (Array.isArray(data.items)) {
          this.items = data.items;
          this.totalItems = data.totalCount ?? 0;
        } else {
          this.items = data?.items ?? [];
          this.totalItems = data?.totalCount ?? 0;
        }

      })
      .catch(error => {
        this.mostrarKO("productos.koListado");
      })
      .finally(() => {
        this.closeSpinner();
      });
  }

  nuevoElemento(): void {
    this.popupHeaderText = "productos.nuevoElemento";
    this.itemEdit = {  activo: true ,    enviarATriton: true,           // ← Method default
    enviarAltura: true,
    destinatariosNotificacionAltura: []
};
    this.isOpenForm = true;
  }

  tableEventAction(action: string, item: any): void {
    switch (action) {
      case 'eliminar':
        this.itemEliminar = item;
        this.showDialog = true;
        break;

      case 'editar':
        this.popupHeaderText = "productos.editarElemento";
        this.itemEdit = {};
        this.openSpinner("productos.cargar");
        this.get({ apiUrl: `/api/producto/${item.id}` })
          .then((response) => {
            this.itemEdit = response;
            this.itemEdit["$item_id"] = item.id;
            const rawIds = this.itemEdit.IdUsuariosDestinatariosNotificacionAltura
              ?? this.itemEdit.idUsuariosDestinatariosNotificacionAltura
              ?? this.itemEdit.destinatariosNotificacionAltura
              ?? [];

            const ids = Array.isArray(rawIds) ? rawIds : (rawIds == null ? [] : [rawIds]);

            const selected = ids.map((val: any) => {
              const key = String(val).trim();
              if (!key) {
                return val;
              }
              const match = this.maestroUsuariosNotificacionAltura.find((u: any) => String(u?.id ?? '').trim() === key);
              return match ?? val;
            });

            this.itemEdit.destinatariosNotificacionAltura = selected;
            if (this.itemEdit.enviarAltura === undefined) {
              this.$set(this.itemEdit, 'enviarAltura', false);
            }
            this.closeSpinner();
            this.isOpenForm = true;
          })
          .catch(() => {
            this.mostrarKO("productos.errorCargar");
            this.closeSpinner();

          });
        break;
      default:
        break;
    }
  }

  private eliminarProducto() {
    this.showDialog = false;
    this.openSpinner("productos.eliminarExitosa");
    this.delete({ apiUrl: `/api/producto`, entity: this.itemEliminar })
      .then(() => {
        // Manejar la respuesta si es necesario
        this.closeSpinner();
        this.mostrarOK("productos.eliminarExitosa");

        // Actualizar el listado después de la eliminación
        this.getProductosList();
      })
      .catch(() => {

        this.closeSpinner();
        this.mostrarKO("productos.errorEliminar");
      });
  }

  private buildProductoPayload(item: any): any {
    const payload: any = { ...item };

    // Don't send internal UI-only fields
    delete payload['$item_id'];

    const normalizeBool = (value: any): any => {
      if (value === true || value === false) {
        return value;
      }
      if (value === 1 || value === 0) {
        return Boolean(value);
      }
      if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase();
        if (normalized === 'true' || normalized === '1' || normalized === 'si' || normalized === 'sí') {
          return true;
        }
        if (normalized === 'false' || normalized === '0' || normalized === 'no') {
          return false;
        }
      }
      return value;
    };

    payload.activo = normalizeBool(payload.activo);
    payload.cierreAutomatico = normalizeBool(payload.cierreAutomatico);
    payload.enviarATriton = normalizeBool(payload.enviarATriton);

    const normalizedEnviarAltura = normalizeBool(payload.enviarAltura);
    if (normalizedEnviarAltura === true || normalizedEnviarAltura === false) {
      payload.enviarAltura = normalizedEnviarAltura;
    } else {
      payload.enviarAltura = false;
    }

    const raw = payload.destinatariosNotificacionAltura;
    const values: any[] = Array.isArray(raw) ? raw : (raw == null ? [] : [raw]);

    const normalized: Array<string | number> = [];
    const seen = new Set<string>();

    const addUnique = (val: any) => {
      if (val == null) {
        return;
      }
      const key = String(val).trim();
      if (!key || seen.has(key)) {
        return;
      }
      seen.add(key);
      normalized.push(val);
    };

    const resolveToKnownId = (rawValue: string): any => {
      const trimmed = rawValue.trim();
      if (!trimmed) {
        return '';
      }

      const byId = this.maestroUsuariosNotificacionAltura.find((u: any) => String(u?.id ?? '').trim() === trimmed);
      if (byId?.id != null) {
        return byId.id;
      }

      const byNombre = this.maestroUsuariosNotificacionAltura.find((u: any) => String(u?.nombre ?? '').trim() === trimmed);
      if (byNombre?.id != null) {
        return byNombre.id;
      }

      const byEmail = this.maestroUsuariosNotificacionAltura.find((u: any) => String(u?.email ?? '').trim() === trimmed);
      if (byEmail?.id != null) {
        return byEmail.id;
      }

      // Keep numeric ids as numbers
      if (/^\d+$/.test(trimmed)) {
        return Number(trimmed);
      }

      // Keep typed emails/strings if not found in the maestro list
      return trimmed;
    };

    values.forEach((v: any) => {
      if (v == null) {
        return;
      }
      if (typeof v === 'number') {
        addUnique(v);
        return;
      }
      if (typeof v === 'string') {
        const resolved = resolveToKnownId(v);
        if (resolved !== '') {
          addUnique(resolved);
        }
        return;
      }
      if (typeof v === 'boolean') {
        return;
      }

      const candidate = v.idUsuario ?? v.usuarioId ?? v.id ?? v.identificador ?? v.codigoUsuario ?? v.email;
      if (candidate == null) {
        const fallbackNombre = v.nombre != null ? String(v.nombre) : '';
        const resolved = resolveToKnownId(fallbackNombre);
        if (resolved !== '') {
          addUnique(resolved);
        }
        return;
      }
      if (typeof candidate === 'number') {
        addUnique(candidate);
        return;
      }
      const resolved = resolveToKnownId(String(candidate));
      if (resolved !== '') {
        addUnique(resolved);
      }
    });

    payload.destinatariosNotificacionAltura = normalized;
    payload.IdUsuariosDestinatariosNotificacionAltura = normalized;
    payload.idUsuariosDestinatariosNotificacionAltura = normalized;
    return payload;
  }

  formEventAction(action: string, item: any): void {
    switch (action) {
      case 'salvar': {
        const payload = this.buildProductoPayload(item);
        if (item["$item_id"]) {
          this.openSpinner("productos.actualizarElemento");
          this.put({ apiUrl: `/api/producto/${item["$item_id"]}`, entity: payload })
            .then(() => {
              this.isOpenForm = false;
              this.closeSpinner();
              this.mostrarOK("productos.actualizacionExitosa");
              this.getProductosList();
            })
            .catch(() => {
              this.closeSpinner();
              this.mostrarKO("productos.errorActualizacion");
            });
        } else {
          this.openSpinner("productos.crearElemento");
          this.post({ apiUrl: '/api/producto', entity: payload })
            .then(() => {
              this.isOpenForm = false;
              this.closeSpinner();
              this.mostrarOK("productos.creacionExitosa");
              this.getProductosList();
            })
            .catch(() => {
              this.closeSpinner();
              this.mostrarKO("productos.errorCreacion");
            });
        }
        break;
      }

      case 'cancelar':
        this.isOpenForm = false;
        break;

      case 'cambio':
        // Código relacionado con 'cambio'
        if (item.limiteInicial) {
          this.rulesForm.limiteSuperior = [this.required(), this.minLen(item.limiteInicial)]
        } else {
          this.rulesForm.limiteSuperior = [this.required(), this.minLen(0)]
        }

        this.formIsValid = item.limiteInicial < item.limiteSuperior;

        break;

      default:
        // Cualquier otro código que necesites manejar para otros casos
        break;
    }
  }

  changeFilters(): void {
    this.filterChips.splice(0);
    this.filterFields.forEach(f => {
      if (f.model) {
        if (Array.isArray(f.model)) {
          f.model.forEach(m => {
            this.filterChips.push({ clave: `${f.name}-${m.id}`, valor: m.nombre, tooltip: f.label });
          })
        }
        else {
          this.filterChips.push({ clave: `${f.name}`, valor: f.model as string, tooltip: f.label });
        }
      }
    });

    this.isOpenFilters = false;

    //hacer la llamada al listado
    this.getProductosList();

  }

  removeChip(clave: string): void {
    if (clave) {
      this.filterChips = this.filterChips.filter(c => c.clave != clave);

      var name = clave.split('-')[0];
      var field = this.filterFields.find(f => f.name == name);
      if (field) {
        if (Array.isArray(field.model)) {
          var id = clave.split('-')[1];
          field.model = field.model.filter(m => m.id != id);
        }
        else {
          field.model = '';
        }
      }
      this.getProductosList();
    }
  }

  rulesForm = {
    codigo: [this.required(), this.maxLen(20)],
    nombre: [this.required(), this.maxLen(255)],
    codigoMercado: [this.required(), this.maxLen(20)],
    codigoTriton: [this.required(), this.maxLen(20)],
    limiteInicial: [this.required(), this.minLen(1)],
    limiteSuperior: [this.required(), this.minLen(1)],
    horaCierrePorDefecto: [this.required()],
    diaCierreLineaPorDefecto: [this.required()],
    mesesCierre1Linea: [this.range(0, 12)],
    mesesCierre2Linea: [this.range(0, 12)],
    activo: [this.required()],
    cierreAutomatico: [this.required()],
    enviarATriton: [this.required()],             
    enviarAltura: [this.required()],  
    minCierreOperacionesPrevioAlCierre: [this.required()],
    codigosMesas: [(field: any[]) =>
    (Array.isArray(field) && field.length > 0) ||
    this.$t('validations_form.required')]
  };



}

export default ProductosPage;
